// src/components/OnBoardZid.jsx
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import EmailVerification   from './EmailVerification/EmailVerification';
import BusinessInformation from './BusinessVerification/BusinessVerification';
import CompletionOnboarding from './Completion/CompletionOnboarding';
import ProgressBar         from './Components/StepIndication';

export default function OnBoardSalla() {
  const { t, i18n } = useTranslation();

    useEffect(() => {
   if (i18n.language !== 'ar') {
   i18n.changeLanguage('ar');
  }
 }, [i18n]);
 
  const TOTAL_STEPS = 3;

  const location = useLocation();
  const navigate = useNavigate();
  const [step, setStep] = useState(1);

  // seed email and business data from router state
  const userEmailDefault   = location.state?.user?.email   || '';
  const storeNameDefault   = location.state?.store?.name   || '';
  const accessToken        = location.state?.store?.access_token || '';
  const storeUrlDefault    = location.state?.store?.url    || '';
  const firstName          = location.state?.user?.name || '';
  const store_id = location.state?.store?.id || ''

  console.log(store_id)

  const [verifiedEmail, setVerifiedEmail] = useState(userEmailDefault);
  const [businessData, setBusinessData]   = useState({
    companyName: storeNameDefault,
    website:     storeUrlDefault,
    revenue:     '',
    language:    '',
    industry:    '',
  });

  useEffect(() => {
    if (!location.state?.user || !location.state?.store) {
      navigate('/', { replace: true });
    }
  }, [location.state, navigate]);

  if (!location.state?.user || !location.state?.store) {
    return null;
  }

  const payload = {
    email:       verifiedEmail,
    username:    storeUrlDefault,
    first_name:  firstName,
    sallaToken: accessToken,
    store_id:store_id,
    ...businessData,
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4">
      <div className="max-w-md mx-auto mb-6">
        <ProgressBar currentStep={step} totalSteps={TOTAL_STEPS} />
        <p className="text-center text-sm text-gray-600 mt-2">
          {t('zidOnboarding.stepLabel', { step, totalSteps: TOTAL_STEPS })}
        </p>
        {/* Back button */}
        {step > 1 && (
          <div className="flex justify-start mt-4">
            <button
              onClick={() => setStep(step - 1)}
              className="px-4 py-2 bg-gray-200 text-gray-700 rounded hover:bg-gray-300"
            >
              {t('zidOnboarding.back')}
            </button>
          </div>
        )}
      </div>

      {step === 1 && (
        <EmailVerification
          initialEmail={verifiedEmail}
          onVerified={(newEmail) => {
            setVerifiedEmail(newEmail);
            setStep(2);
          }}
        />
      )}

      {step === 2 && (
        <BusinessInformation
          initialCompanyName={businessData.companyName}
          initialWebsite={businessData.website}
          onVerified={(data) => {
            setBusinessData(data);
            setStep(3);
          }}
        />
      )}

      {step === 3 && (
        <CompletionOnboarding
          payload={payload}
          onComplete={() => navigate('/user/chatbot')}
        />
      )}

      <div className="fixed bottom-4 right-4">
        <button
          onClick={() => i18n.changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}
          className="px-3 py-1 border rounded"
        >
          {t('zidOnboarding.switchLanguage')}
        </button>
      </div>
    </div>
  );
}

